export default __webpack_public_path__ + "static/media/product_test_discovery_hea.8bd5793c.jpg";